import { render, staticRenderFns } from "./InsuranceQuestions.vue?vue&type=template&id=b066efee"
import script from "./InsuranceQuestions.vue?vue&type=script&lang=js"
export * from "./InsuranceQuestions.vue?vue&type=script&lang=js"
import style0 from "./InsuranceQuestions.vue?vue&type=style&index=0&id=b066efee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports